import { BusinessError } from '@/error';
import { FormDataGetStoreBaromoney } from '@/form/form-data/FormDataGetStoreBaromoney';
import { whereOperators } from '@/lib/query-parameter/filter';
import StoreBaromoney from '@/lib/sales/StoreBaromoney';
import { GetStoreBaromoney } from '@/service-data/sales/GetStoreBaromoney';
import { storeService } from '@/services';
import { salesService } from '@/services/sales';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { userGetterType } from '@/vuex-store/user/getters';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
// 상점 바로머니
export const piniaStoreBaromoney = defineStore('storeBaromoney', () => {
    // STATE
    const formData = ref(new FormDataGetStoreBaromoney());
    /** 원본 폼 데이터 (초기화에서 사용) */
    const originFormData = ref(new FormDataGetStoreBaromoney());
    /** 캘린더 다이얼로그의 날짜 출력용 날짜 데이터 */
    const datePickerDate = ref([]);
    /** 최소 날짜 */
    const minDate = ref('');
    /** 최대 날짜 */
    const maxDate = ref('');
    /** 월별 기간 최대 개월 수 3개월까지 가능 */
    const maxPeriodMonthly = ref(3);
    /** 기간 최대 일자 90일까지 가능 */
    const maxPeriod = ref(90);
    /** 제출 여부 */
    const isSubmit = ref(false);
    /** 초기화 여부 */
    const isInit = ref(false);
    /** 매출 인스턴스 */
    const thisSalesInstance = ref(null);
    /** 매출 데이터 */
    const salesData = ref([]);
    /** 매출 시리즈 데이터 (그래프에서 사용) */
    const salesSeriesData = ref([]);
    /** 매출 총계 데이터 */
    const totalData = ref({});
    /** 상점 리스트 */
    const storeList = ref([]);
    /** 초기화 되지 않는 데이터 */
    const prevData = ref({
        pageSizeType: '',
        pageNumber: 0,
    });
    /** 캘린더 퀵 메뉴 */
    const calQuickMenu = ref([]);
    // COMPUTED
    const formDataDateToString = computed(() => formData.value.date.join('~'));
    /** 테이블 텍스트 */
    const noDateText = computed(() => {
        if (!isInit.value) {
            return '매출 조회를 클릭해 주세요.';
        }
        return '데이터가 없습니다.';
    });
    /**
     * 허브 리스트
     */
    const hubList = computed(() => vuexStore.state.hubSelector.hubs);
    // ACTION
    /**
     * 통계 조회
     */
    const getSales = async () => {
        try {
            const response = await salesService.getStoreBaromoney(new GetStoreBaromoney(formData.value));
            salesData.value = response.list;
            totalData.value = thisSalesInstance.value.makeTotalData(response.list);
        }
        catch (error) {
            if (error instanceof BusinessError) {
                vuexStore.dispatch(snackbarActionType.showError, error.message);
            }
        }
    };
    /**
     * 상점 리스트
     */
    const getStoreList = async () => {
        const filters = [];
        filters.push({
            condition: whereOperators.equals,
            field: 'hubId',
            value: formData.value.selectedHubId,
        });
        try {
            const response = await storeService.getStoreList({
                filters,
            });
            storeList.value = response.list;
            // 첫번째 상점 선택, 없으면 공백
            formData.value.selectedStoreId = response.list.length > 0
                ? response.list[0].code
                : '';
        }
        catch (error) {
            if (error instanceof BusinessError) {
                console.log(error);
            }
        }
    };
    /**
     * 초기화
     */
    const init = () => {
        thisSalesInstance.value = new StoreBaromoney();
        thisSalesInstance.value.initPageHeaderData();
        thisSalesInstance.value.initExcelConfig();
        thisSalesInstance.value.initDate();
        formData.value.selectedHubId = vuexStore.getters[userGetterType.hubId];
        formData.value.date = thisSalesInstance.value.date;
        datePickerDate.value = [
            ...formData.value.date,
        ];
        maxDate.value = formData.value.date?.[1];
        salesData.value = [];
        salesSeriesData.value = [];
        totalData.value = {};
    };
    return {
        init,
        salesData,
        noDateText,
        totalData,
        calQuickMenu,
        formData,
        formDataDateToString,
        thisSalesInstance,
        originFormData,
        hubList,
        datePickerDate,
        minDate,
        maxDate,
        maxPeriodMonthly,
        maxPeriod,
        isSubmit,
        isInit,
        getSales,
        getStoreList,
        storeList,
        prevData,
    };
});
